import { createContext } from 'react'
import { createContextualCan } from '@casl/react'

import { ability } from './ability'
import { AnyAbility } from '@casl/ability'

export const AbilityContext = createContext(ability)
export const Can = createContextualCan<AnyAbility>(AbilityContext.Consumer)
